import { createVNode as _createVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = {
  class: "flex w-full justify-between items-center pb-5",
  style: {"border-bottom":"1px solid #CFD8DC"}
}
const _hoisted_2 = /*#__PURE__*/_createVNode("h6", { class: "font-semibold text-xl text-black" }, "Detail Status", -1)
const _hoisted_3 = { class: "p-5" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_HjexTimelineV2 = _resolveComponent("HjexTimelineV2")
  const _component_Card = _resolveComponent("Card")
  const _component_Dialog = _resolveComponent("Dialog")

  return (_openBlock(), _createBlock(_component_Dialog, {
    visible: _ctx.isShowModal,
    "onUpdate:visible": _cache[2] || (_cache[2] = ($event: any) => (_ctx.isShowModal = $event)),
    dismissableMask: true,
    modal: true,
    onHide: _cache[3] || (_cache[3] = ($event: any) => (_ctx.hideDialog())),
    class: "dialog-confirm confirm-cancel-package-dialog w-screen md:w-1/2"
  }, {
    header: _withCtx(() => [
      _createVNode("div", _hoisted_1, [
        _hoisted_2,
        _createVNode("i", {
          class: "pi pi-times text-black cursor-pointer",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.hideDialog()))
        })
      ])
    ]),
    default: _withCtx(() => [
      _createVNode("section", null, [
        _createVNode(_component_Card, { class: "card-no-shadow card-p-0 mb-8" }, {
          content: _withCtx(() => [
            _createVNode("div", _hoisted_3, [
              (!_ctx.isLoading)
                ? (_openBlock(), _createBlock(_component_HjexTimelineV2, {
                    key: 0,
                    datas: _ctx.dataSource
                  }, null, 8, ["datas"]))
                : _createCommentVNode("", true)
            ])
          ]),
          _: 1
        })
      ])
    ]),
    _: 1
  }, 8, ["visible"]))
}